export const isCI = true
export const isPR = false
export const name = `GitHub Actions`